import React, { useEffect, useRef, useCallback, useMemo } from 'react'
import classNames from 'classnames'
import { HeaderAccountSelector } from './components/HeaderAccountSelector'
import { HeaderSearch } from './components/HeaderSearch'
import { HeaderBurger } from './components/HeaderBurger'
import { HeaderSearchField } from './components/HeaderSearchField'
import cls from './header.module.scss'
import Logo from '~src/new/shared/ui/Logo/Logo'
import { useWidth } from '~src/new/app/providers/WidthProvider'
import { Link } from 'react-router-dom'
import { useMember } from '~src/new/app/providers/MemberProvider'
import { HeaderItem } from './components/HeaderItem'
import { Menu } from '~src/new/widgets/Menu'
import { useModalSheet } from '@/src/app/providers/ModalSheetProvider/lib/useModalSheet'

const MENU_ID = 'main-menu'

/**
 * Мобильный Header компонент
 * @component
 */
export const Header = props => {
  const { className, items, menuItems, style, history, isLoading, isMobileLayout } = props

  const { closeModal, toggleModal, isFullScreenOpen, id } = useModalSheet()
  const { member, isArchiveAccount } = useMember()

  const companyWrapperRef = useRef(null)
  const searchWrapperRef = useRef(null)

  const { isMobile: isMobileByWidth } = useWidth()
  const isMobile = isMobileLayout !== undefined ? isMobileLayout : isMobileByWidth

  const isMenuOpen = useMemo(() => {
    return id === MENU_ID
  }, [id])

  const handleMenuMobileList = useCallback(() => {
    toggleModal({
      content: <Menu className={cls.menu} items={menuItems} onItemClick={closeModal} />,
      id: MENU_ID,
      props: {
        isFullScreen: true,
        theme: 'black',
      },
    })
  }, [toggleModal, menuItems, closeModal])

  const handleSearchMobileList = useCallback(() => {
    toggleModal({
      content: (
        <div>
          <HeaderSearchField onClick={closeModal} isMobile />
        </div>
      ),
      props: {
        isFullScreen: true,
        theme: 'black',
      },
    })
  }, [toggleModal, closeModal])

  const handleMenuToggle = useCallback(() => {
    if (!isMobile) return
    handleMenuMobileList()
  }, [isMobile, handleMenuMobileList])

  const toggleSearch = useCallback(() => {
    if (!isMobile) return
    handleSearchMobileList()
  }, [isMobile, handleSearchMobileList])

  useEffect(() => {
    if (!isArchiveAccount) return
    const unavailableMenuItems = [
      '/my-programs',
      '/loyalty',
      '/world-of-tobacco',
      '/my-programs-kb',
      '/edu-actions',
      '/notifications',
      '/tasks',
      '/site-services',
    ]

    const isUnavailableRoute =
      history.location?.pathname === '/' ||
      unavailableMenuItems.some(route => {
        return history.location?.pathname.indexOf(route) !== -1
      })

    if (isUnavailableRoute) {
      history.push('/profile')
    }
  }, [history, member, history.location?.pathname, history.location?.search, isArchiveAccount])

  const isAccountDropDownVisible = items?.find(
    ({ component }) => component === 'HeaderItemDropDown',
  )
  const isSearchBarVisible = items?.find(({ component }) => component === 'SearchBar')

  const [leftItems, rightItems] = useMemo(() => {
    if (!items?.length) return [[], []]
    const filteredItems = items.filter(
      ({ component }) => component === 'HeaderItem' || component === 'HeaderItemNotificationCenter',
    )
    if (!isMobile) return [[], filteredItems]
    const profileItemIndex = filteredItems?.findIndex(
      ({ component, props }) => component === 'HeaderItem' && props.to === '/profile',
    )
    if (profileItemIndex === -1) return [[], filteredItems]
    const profileItem = filteredItems[profileItemIndex]
    filteredItems.splice(profileItemIndex, 1)
    return [[profileItem], filteredItems]
  }, [items, isMobile])

  if (!items?.length) return null

  return (
    <header
      id="header"
      className={classNames(cls.header, className, {
        [cls.headerLoading]: isLoading,
        [cls.withoutBorderRadius]: isFullScreenOpen,
      })}
      style={style}
    >
      <div className={cls.headerContainer}>
        <div className={cls.headerLeft} ref={companyWrapperRef}>
          {leftItems?.length > 0 &&
            leftItems.map(({ props }) => <HeaderItem key={props.to} {...props} />)}
          <Link to="/" className={cls.logoWrapper}>
            <Logo variant="white" className={cls.logo} />
          </Link>
          {isAccountDropDownVisible ? (
            <HeaderAccountSelector className={cls.companySelector} isMobile={isMobile} />
          ) : null}
        </div>

        {!isMobile && isSearchBarVisible ? (
          <div className={cls.headerCenter} ref={searchWrapperRef}>
            <HeaderSearchField className={cls.searchField} />
          </div>
        ) : null}

        <div className={cls.headerRight}>
          {isMobile && isSearchBarVisible ? (
            <HeaderSearch onClick={toggleSearch} className={cls.headerIcon} />
          ) : null}
          {rightItems.map(({ props }) => (
            <HeaderItem key={props.to} {...props} isMobile={isMobile} />
          ))}

          {isMobile ? (
            <HeaderBurger
              isOpen={isMenuOpen}
              onClick={handleMenuToggle}
              className={cls.headerIcon}
            />
          ) : null}
        </div>
      </div>
    </header>
  )
}
